import { z } from 'zod'

export const ConfigSchema = z.object({
  backendServiceUrl: z.string(),
  sentry: z
    .object({
      enabled: z.string(),
      dsn: z.string(),
      environment: z.string()
    })
    .nullish(),
  softwareVersion: z.string()
})

export type Config = z.infer<typeof ConfigSchema>
